export default __webpack_public_path__ + "static/media/visuel-home-zoom-min.45441be5.jpg";